import config from "@/plugins/config.js";

export default {
	install: (app) => {
		app.config.globalProperties.$config = config;
	},
};
